export const CURRENCY_FALLBACK = "$0";

function sanitizePositiveDecimal(rawInput) {
  if (rawInput == null) return "";

  let cleaned = String(rawInput).replace(/[^0-9.]/g, "");
  const firstDot = cleaned.indexOf(".");

  if (firstDot !== -1) {
    cleaned =
      cleaned.slice(0, firstDot + 1) +
      cleaned.slice(firstDot + 1).replace(/\./g, "");
  }

  return cleaned;
}

function stripLeadingZeroes(intPart) {
  return intPart.replace(/^0+(\d)/, "$1");
}

export function formatPositiveDecimalInput(rawInput) {
  const cleaned = sanitizePositiveDecimal(rawInput);

  if (cleaned === "") return "";

  const [rawIntPart, decPart] = cleaned.split(".");
  const intPart = stripLeadingZeroes(rawIntPart);

  if (decPart !== undefined) {
    return `${intPart}.${decPart.slice(0, 2)}`;
  }

  return intPart;
}

export function formatCurrencyInput(rawInput, currencySymbol = "$") {
  const cleaned = sanitizePositiveDecimal(rawInput);

  if (cleaned === "" || cleaned === ".") return `${currencySymbol}0`;

  const [rawIntPart, decPart] = cleaned.split(".");
  const intPart = stripLeadingZeroes(rawIntPart);

  const intWithCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  if (decPart !== undefined) {
    return `${currencySymbol}${intWithCommas}.${decPart.slice(0, 2)}`;
  }

  return `${currencySymbol}${intWithCommas}`;
}

export function formatWholeNumberInput(rawInput) {
  if (rawInput == null) return "";

  const cleaned = String(rawInput).replace(/\D/g, "");

  if (cleaned === "") return "";

  return stripLeadingZeroes(cleaned);
}

export function normalizeCommittedValue(value, { currency = false } = {}) {
  let committed = value ?? "";

  if (committed.endsWith(".")) {
    committed = committed.slice(0, -1);
  }

  if (currency) {
    return committed.replace(/^\$\.(\d)/, "$0.$1");
  }

  return committed.replace(/^\.(\d)/, "0.$1");
}

/**
 * @deprecated `FormattedInput` is a bare `<input>` element kept for
 * historical reasons. For new code prefer `Input` from `components/shared`
 * combined with one of the `format*Input` utilities from this file:
 *
 *   import Input from "components/shared/Input/Input";
 *   import { formatCurrencyInput } from ".../FormattedInput/FormattedInput";
 *
 *   const [value, setValue] = useState("");
 *   <Input value={value} onChange={(e) => setValue(formatCurrencyInput(e.target.value))} />
 *
 * The `format*Input` and `normalizeCommittedValue` helpers above stay
 * exported and supported — only the bare-input wrapper is deprecated.
 * Migration of existing consumers happens incrementally during cleanup
 * waves (the antd-styled wrapper changes the visual contract).
 */
function FormattedInput({ formatter, onChange, value, ...props }) {
  return (
    <input
      {...props}
      value={value ?? ""}
      onChange={(event) =>
        onChange?.(formatter ? formatter(event.target.value) : event.target.value)
      }
    />
  );
}

export default FormattedInput;
